import { tileVariantOf } from "../../utilities/item-kinds";
import StampTile from "./tiles/StampTile";
import CoverTile from "./tiles/CoverTile";
import ArticleTile from "./tiles/ArticleTile";

function tileFor(item) {
  switch (item.kind) {
    case "cover":
      return <CoverTile item={item} />;
    case "article":
      return <ArticleTile item={item} />;
    default:
      return <StampTile item={item} />;
  }
}

function isWide(item) {
  const variant = tileVariantOf(item);
  return (
    (item.kind === "cover" && variant.startsWith("landscape")) ||
    (item.kind === "article" && variant === "wide")
  );
}

export default function MosaicGrid({ items }) {
  const cells = items.map((item) => (
    <div key={item._id} className={isWide(item) ? "col-span-2" : ""}>
      {tileFor(item)}
    </div>
  ));

  // Tile geometry: everything scales from one unit --u so ratios stay
  // constant at every width — a single tile is 235u × 300u, the gap 16u,
  // and a wide (2-col) tile 486u × 300u. For n columns the container is
  // (251n − 16)u wide, hence --u = 100cqw / (251n − 16) per breakpoint.
  // Caps at 5 columns; the site container is sized to match (1239px).
  return (
    <div style={{ containerType: "inline-size" }}>
      <div className="grid grid-flow-dense grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 [--u:calc(100cqw/486)] md:[--u:calc(100cqw/737)] lg:[--u:calc(100cqw/988)] xl:[--u:calc(100cqw/1239)] [grid-auto-rows:calc(var(--u)*300)] [gap:calc(var(--u)*16)]">
        {cells}
      </div>
    </div>
  );
}
